// dependency-graph-ignore-file
import { type Database } from '@databases/model/database';

export function setFieldName(ydb: Database, fieldId: string, delta: any[]): void {
  ydb.mutate((db) => {
    const field = db.fieldsById[fieldId];

    if (field) {
      field.applyNameDelta(delta);
    }
  });
}
